import React from 'react';
import CryptoTicker from './components/CryptoTicker';

function App() {
  return (
    <div className="App">
      <CryptoTicker />
    </div>
  );
}

export default App; 